import { useState } from "react";
import { Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { LoadingButton } from "@mui/lab";
import { storeStateType, useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import {
  addWorktype,
  editWorktype,
} from "../../redux/actions/worktype.actions";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ModalBoxHeader from "../../components/ModalBoxHeader";

export default function AddWorktypeModal(props: any) {
  const { setShowAddWorktypeModal, selectedWorktype, titleName } = props;

  const loading = useSelector(
    (state: storeStateType) => state.worktype.loading
  );
  const [worktype, setWorktype] = useState<string>(
    selectedWorktype?.worktype ?? ""
  );
  const dispatch = useAppDispatch();

  function handleModalClose() {
    setShowAddWorktypeModal(false);
  }
  function handleSave(e: any) {
    e.preventDefault();
    if (selectedWorktype) {
      if (worktype) dispatch(editWorktype(worktype, selectedWorktype.id));
    } else {
      if (worktype) dispatch(addWorktype(worktype));
    }
  }
  return (
    <Modal
      open={true}
      className=""
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="rostme-modal"
        position="relative"
        sx={{ backgroundColor: "background.paper" }}
      >
        <ModalBoxHeader
          title={`New ${titleName}`}
          handleClose={handleModalClose}
        />

        <Box className="modal-body">
          <form>
            <Grid container spacing={1} px={2}>
              <Grid item xs={12}>
                <TextField
                  label={titleName}
                  value={worktype}
                  fullWidth
                  onChange={(e) => setWorktype(e.target.value)}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} display="flex" justifyContent={"flex-end"}>
                <LoadingButton
                  sx={{ width: "120px", my: 1 }}
                  disabled={worktype ? false : true}
                  onClick={handleSave}
                  loading={loading ? true : false}
                  type="submit"
                  className="rostme-button"
                  variant="contained"
                >
                  Save
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}
